import { createReducer } from '@reduxjs/toolkit';

import {
  setClassificationLoading,
  setClassificationError,
  addClassificationResult,
  clearClassification,
  clearCommunityClassification,
  setFileUploading,
} from './actions';
import { initialState } from './initialState';

/**
 * Classification reducer - handles only classification state
 */
export const classificationReducer = createReducer(initialState, builder => {
  builder
    // Classification actions
    .addCase(setClassificationLoading, (state, action) => {
      state.isLoading = action.payload;
    })
    .addCase(setFileUploading, (state, action) => {
      state.isFileUploading = action.payload;
    })
    .addCase(setClassificationError, (state, action) => {
      state.errors = action.payload;
    })
    .addCase(addClassificationResult, (state, action) => {
      const { communityId, result } = action.payload;

      // Initialize the array if it doesn't exist
      if (!state.classificationResults[communityId]) {
        state.classificationResults[communityId] = [];
      }

      // Add the result to the beginning of the array (most recent first)
      state.classificationResults[communityId].unshift(result);
    })
    .addCase(clearClassification, state => {
      state.classificationResults = {};
      state.errors = null;
    })
    .addCase(clearCommunityClassification, (state, action) => {
      const communityId = action.payload;

      if (communityId in state.classificationResults) {
        state.classificationResults[communityId] = [];
      }
    });
});
